import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';

import Radio from 'bharat-ui/web/Radio';
import Icon from 'bharat-ui/web/Icon';
import Badge from 'bharat-ui/web/Badge';
import FormControlLabel from 'bharat-ui/web/FormControlLabel';
import unityChecked from 'assets/images/unityChecked.png';
import { PaymentOptionProps } from './PaymentOption.types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	root: {
		'& .MuiFormControlLabel-root': {
			marginLeft: '0px',
		},
	},
	disabled: {
		pointerEvents: 'none',
		opacity: 0.5,
	},
	recomended: {
		position: 'absolute',
		right: '15px',
		top: '16px',
	},
	recomendedLeft: {
		marginLeft: '16px',
	},
	rightContent: {
		position: 'absolute',
		right: '15px',
		top: '16px',
		display: 'flex',
		alignItems: 'flex-start',
	},
	postPeRegular400: {
		fontFamily: 'PoppinsRegular',
		fontSize: '15px',
		lineHeight: '19px',
		color: '#1F1F1F',
	},
	postPeLight300: {
		fontFamily: 'PoppinsLight',
		fontSize: '11px', // TODO: Convert to rem
		lineHeight: '16px',
		color: '#4F4F4F',
	},
});

const PaymentOption: React.FC<PaymentOptionProps> = ({
	id,
	title,
	subtitle,
	showChildren,
	children,
	recommended,
	recommendedText,
	disabled,
	rightContent,
	onPaymentOptionSelected,
	isShowUnityUi,
}) => {
	const classes = useStyles();
	const getLeftContent = () => {
		return (
			<FormControlLabel
				value={id}
				key={id}
				control={
					isShowUnityUi ? (
						<Radio checkedIcon={<Icon icon={unityChecked} height={21} />} className="p0" />
					) : (
						<Radio className="p0" />
					)
				}
				label=""
				{...(disabled ? disabled : '')}
			/>
		);
	};

	const onClick = (e: any) => {
		if (typeof onPaymentOptionSelected === 'function') {
			onPaymentOptionSelected(id);
		}
	};

	return (
		<div
			className={clsx(
				`flex flex-justify flex-center border-box light-background width-100 p4 relative cursor-pointer`,
				classes.root,
				disabled ? classes.disabled : '',
			)}
			onClick={onClick}>
			<div className="flex width-100 flex-start">
				{getLeftContent()}
				<div className="flex flex-column width-100">
					<div className={`${rightContent ? 'flex flex-row' : ''}`}>
						{title && (typeof title === 'string' ? <span className={classes.postPeRegular400}>{title}</span> : title)}
						{rightContent && recommended && (
							<div className={classes.recomendedLeft}>
								{' '}
								<Badge variant="success" text={recommendedText || 'Recommended'} />{' '}
							</div>
						)}
					</div>
					{subtitle && <span className={`${classes.postPeLight300} ${title ? 'mt2' : ''}`}>{subtitle}</span>}
					{showChildren && children}
				</div>
			</div>
			{!rightContent && recommended && (
				<div className={classes.recomended}>
					{' '}
					<Badge variant="success" text={recommendedText || 'Recommended'} />{' '}
				</div>
			)}
			{rightContent && <div className={classes.rightContent}>{rightContent}</div>}
		</div>
	);
};

PaymentOption.defaultProps = {
	id: -1,
	title: '',
	subtitle: '',
	showChildren: true,
	children: <></>,
	selected: false,
	recommended: false,
	recommendedText: '',
	disabled: false,
};

export default PaymentOption;
